module.exports = __webpack_public_path__ + "static/it-pop-culture-b210ff142bd4d910a10f251dbd23dd77.png";